<template>
    <div :class="tableClass">
        <template v-for="(row, index) in rows">
            <div v-if="row.display" class="row row-border no-side-padding" :key="index">
                <div :class="buildCellClass('label', row.label)">{{ row.label }}</div>
                <div :class="buildCellClass('value', row.value)">{{ row.value }}</div>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        rows: {
            type: Array,
            required: true
        },
        tableClass: {
            type: String,
            required: false
        }
    },
    data() {
        return {}
    },
    methods: {
        buildCellClass(cellType, cellText) {
            if (cellText) {
                return cellType === "label" ? 'col xs-8 xm-8 md-8 lg-8 xl-8 bold right center-vertically ': 'col xs-4 sm-4 md-4 lg-4 xl-4 right center-vertically ';
            } else {
                return 'col xs-6 sm-6 md-6 lg-6 xl-6 padding-bottom center-vertically';
            }
        }
    }
}
</script>

<style scoped>
    .right {
        text-align: right;
    }
    .left {
        text-align: left;
    }
    .col-header {
        color: #999;
    }

    .center-vertically {
        margin: auto 0;
    }

    .col {
        margin-right: -1px /* fix styling for Safari */
    }

    .padding-top-2 {
        padding-top: 50px;
    }

    .no-side-padding {
        padding-left: 0px;
        padding-right: 0px;
    }
</style>
